<template>
  <div class="page-wrap" >
    <div class="logo" @click.prevent="show = true" style="opacity: 0">
      <img src="/static/as/images/logo.png?s=2" alt="" >
    </div>

    <div class="slogan" @click.prevent="show = true">
      <img src="/static/as/images/slogan.png" alt="" >
    </div>

    <div class="reward" @click.prevent="show = true">
      <img src="/static/as/images/reward.png?s=2" alt="" >
    </div>

    <div class="action" @click.prevent="show = true">
      <span class="invite-link" >
        立即推荐 · 双向返券
      </span>
    </div>

  <!--
    <div class="qrcode">
      <img src="/static/as/images/qrcode.jpg" alt="" class="code">      
    </div>
  -->

    <div class="gift-status" >
      <van-row class="gift-status-title"  >
         <van-col span="24">
           <div class="title-name">分享进展</div>
           <span class="title-more"  @click="$router.push('/gift-status')">查看明细<van-icon name="arrow" style="margin-left: 2px;font-size: 8px;"/></span>
         </van-col>
      </van-row>
      <van-row class="gift-status-content">
        <van-col span="8" class="gift-stat">
          <div class="gift-money"> <span>{{stat.noRegister}}</span> 人</div>
          <div class="gift-stat-desc">待注册</div>
       </van-col>
       <van-col span="8" class="gift-stat">
          <div class="gift-money"> <span>{{stat.noOrder}}</span> 人</div>
          <div class="gift-stat-desc">待下单</div>
       </van-col>
        <van-col span="8" class="gift-stat">
          <div class="gift-money"> <span>{{stat.paid}}</span> 人</div>
          <div class="gift-stat-desc">已完结</div>
       </van-col>
       </van-row>
    </div>
    <!--
    <div class="gift-status" @click="$router.push('/withdraw')" >
      <van-row class="gift-withdraw">
         <van-col span="24" >
            <div style="display:inline-block;" >已获取总金额： <span class="gift-money"> <span>{{amount}}</span> 元</span></div>
            <div style="color: #9a9595; float: right; margin-top: 5px;font-size: 12px;"> 去提现<van-icon name="arrow"  style="font-size: 10px; "></van-icon> </div>
         </van-col>
      </van-row>
    </div>
    -->

    <van-popup v-model="show" position="top" :overlay="true" class="share-box">
      <div class="click-tip">
        <img src="/static/as/images/gift-share@2x.png" alt="">
      </div>

    </van-popup>
    
  </div>
</template>

<script>

import {Popup,Row, Col, Icon,Toast } from 'vant';
import _ from 'lodash';
export default {
  props: ['message'],
  components: {
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Row.name]: Row,
    [Toast.name]: Toast,
    [Col.name]: Col,
    [Icon.name]: Icon 
  },
  name: 'Gift',
  data () {
    return {
      msg: '没有找到页面',
      show: false,
      amount: 0,
      stat: {
        noRegister: 0,
        noOrder: 0,
        paid:0
      }
    }
  },
  mounted() {
    if (false && this.currentUser().role != 'user') {
      Toast({message: "内部用户无法在当前页面查看分享数据，请至后台查看。",duration: 1500})
     } else {
       this.$http.get("/api/user/amount")
        .then(response => {
          if (response) {
            let {amount} = response.data.data;
            this.amount = amount;
          }
        })
        this.$http.get("/api/qrcode_source/stat")
        .then(response => {
          if (response) {
            this.stat = response.data.data;
          }
        })
     }
    
    this.toshare();

  }
  ,
  methods: {
    goback() {
      this.$router.go(-1);
    },
    currentUser: function() {
      return this.$store.state.user;
    },
    toshare () {
      // alert("准备分享页面，当前是否是微信客户端: " + this.$wechat.isWX)
      if (this.$wechat.isWX) {
        this.doshare();
      } else {
        
      }
    },

    shareConfig(domain) {
      let user = this.currentUser();
      this.$wx.onMenuShareTimeline({
        title: '同城保约惠接力', // 分享标题
        link: `${domain}/share/${user.id}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: `${domain}/static/as/images/logo-circle.png`, // 分享图标
        success: () => {
          // 用户点击了分享后执行的回调函数
          Toast("你已经成功分享到朋友圈");
          console.log("分享到朋友圈成功");
        }
      })

      this.$wx.onMenuShareAppMessage({
        title: '同城保约惠接力', // 分享标题
        desc: '分享让更多人有机会轻松缴纳社保', // 分享描述
        link: `${domain}/share/${user.id}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: `${domain}/static/as/images/logo-circle.png`, // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
        // 用户点击了分享后执行的回调函数
          Toast("你已经成功分享到朋友");
          console.log("分享给朋友成功");
        }
      });
    },
    doshare() {
      console.log("gift 中分享的页面是", window.location.href.split('#')[0]);

      // alert("gift 中分享的页面是: " + window.location.href.split('#')[0]);
      // alert(", window 的 配置页面是: " + window.landingPage);
      if (this.$wechat.isWX) {//只有是微信时，才有意义

      this.$wechat.getSignature(() => {

        this.$http.get("/api/wechat/domain").then(response => {
          if (response) {
            let {domain} = response.data.data;
            
            // alert("当前配置的域名是" + domain);
            // console.log("当前配置的域名是", domain);
  
            this.$wx.ready(() => {
                this.shareConfig(domain);
              })
            this.$wx.error((res) => {
              alert(res.errMsg);
            })
            if (!this.$wechat.isAndroid) {
              this.shareConfig(domain);//iOS ready 不会调用两次
            }
          }
        })
      });

      

      // 原因 是这样的，进入这种页面时，微信发现没有授权的话，会跳转一次。但是只会跳一次。意味着如果用户从其他link进来
      // 比如说首页，就会导致 code 传递的页面 其实是首页。就会失败

        // let url = sessionStorage.getItem("__INIT_WECHAT_URL");

// 原因：微信分享时候会给你当前页面添加多个参数，你sha1时候必须保证url地址是微信给你加了参数之后的地址，这样才不会报config：invalid signature.
        // console.log("当前的URL是", location.href, "session url",url);
        // alert("当前微信URL： "+ url);
        // this.$http.post('/api/wechat/config', {
        //   url: location.href
        // }).then(response => {
        //   if (response) {

        //     console.log("返回值是", response.data.data);
        //     let data = response.data.data;

        //     this.$wx.config({
        //         debug: false,
        //         appId: data.appId,
        //         timestamp: data.timestamp,
        //         nonceStr: data.nonceStr,
        //         signature: data.signature,
        //         jsApiList: [
        //           'checkJsApi',
        //           'onMenuShareTimeline',
        //           'onMenuShareAppMessage',
        //           'onMenuShareQQ',
        //           'onMenuShareWeibo',
        //           'chooseWXPay'
        //         ]
        //       })
            
        //     let domain = data.domain;//从服务器配置的域名
        //     let user = this.currentUser();
        //     this.$wx.ready(() => {
        //       this.$wx.onMenuShareTimeline({
        //         title: '同城保约惠接力', // 分享标题
        //         link: `${domain}/share/${user.id}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //         imgUrl: `${domain}/static/as/images/logo-circle.png`, // 分享图标
        //         success: () => {
        //           // 用户点击了分享后执行的回调函数
        //           Toast("你已经成功分享到朋友圈");
        //           console.log("分享到朋友圈成功");
        //         }
        //       })

        //       this.$wx.onMenuShareAppMessage({
        //         title: '同城保约惠接力', // 分享标题
        //         desc: '分享让更多人有机会轻松缴纳社保', // 分享描述
        //         link: `${domain}/share/${user.id}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //         imgUrl: `${domain}/static/as/images/logo-circle.png`, // 分享图标
        //         type: 'link', // 分享类型,music、video或link，不填默认为link
        //         dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        //         success: function () {
        //         // 用户点击了分享后执行的回调函数
        //           Toast("你已经成功分享到朋友");
        //           console.log("分享给朋友成功");
        //         }
        //       });
        //     })
        //   }
        // }).catch(err => {
        //   console.error(err);
        //   alert("发生异常", err.message);
        // }) 
        
      } else {

      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .page-wrap {
    background-image: url('/static/as/images/bgnew.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    background-color: #FCBB31;
    height: calc(100% - 50px);

    div.logo {
      img{
        width: 40%;
        height: auto;
        margin: 10px;
      }
    }

    div.slogan {
      text-align: center;
      img {
        width: 70%;
        height: auto;
      }
    }

    div.reward {
      text-align: center;
      img {
        width: 60%;
        height: auto;
      }
    }

    div.action {
      text-align: center;
      margin-top: 12px;
      .invite-link {
        color: white;
        background: red;
        border-radius: 5px;
        -webkit-box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.3), 0 1px 2px rgba(0, 0, 0, 0.15);
        box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.3), 0 1px 2px rgba(0, 0, 0, 0.15);
        padding: 8px 10px;
        margin: 5px auto;
            -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
      }
    }

    div.qrcode {
      text-align: center;
      margin: 20px auto;

      background: url('/static/as/images/redpacket.png') no-repeat left 20px bottom 20px;
      background-size: 50px auto;
      

      img.code {
        width: 85px;
        height: auto;
      }

    }

  }
  .gift-status {
    margin: 20px;
    -webkit-box-shadow: rgba(0,0,0,.2) 0 1px 4px, rgba(0,0,0,.2) 0 1px 2px;
    background: #f2f2f4;
    box-sizing: border-box;
    box-shadow: 0 1px 4px rgba(0,0,0,.2), 0 1px 2px rgba(0,0,0,.2);
    border-radius: 5px;

    .gift-status-title {
      padding: 6px;
      background-color: #f3f1f1;
      border-radius: 5px;
      .title-name {
            display: inline-block;
            font-size: 14px;
            font-weight: 500;
      }
      .title-more {
               color: #a09f9f;
        font-size: 12px;
            float: right;
      }
    }
    .gift-money {
        font-size: 14px;
        color: red;
        span {
          font-size: 20px;
        }
      }
    .gift-status-content {
      background-color: #fff;
      padding: 6px;
      border-radius: 5px;
      .gift-stat {
        text-align: center;
        font-weight: 500;
      }
      
      .gift-stat-desc {
        font-size: 12px;
        color: #a09f9f;
        font-weight: 500;
      }
    }

    .gift-withdraw {
     padding: 6px;
      background-color: #fff;
      border-radius: 5px; 
      font-size: 14px;
      font-weight: 500;
      padding-top: 12px;
      padding-bottom: 12px;
    }

  }

  .share-box {
    background-color: transparent;
    color: white;

    .click-tip {
      text-align: right;
      padding-right: 10px;
      padding-top: 10px;

      img {
        width: 90%;
        height: auto;
      }  
    }

    .text-tip{
      margin-top: 150px;
      text-align: center;
      img {
        width: 80%;
        height: auto;
      }  
    }
  }



</style>



// WEBPACK FOOTER //
// src/pages/gift.vue